import React from 'react';
import Immutable from 'immutable';

import {
  CoreLink,
  ImageFromField,
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  Button,
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  FadeWrapper,
  WysiwygField,
} from '../../../components';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
} from '../../../config/constants';

import './style.scss';


const NodeCampaignPage = ({ entity }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'value'], '');
  const fieldLink = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const fieldLinkTitle = entity.getIn(['field_link', 0, 'title']);
  const fieldLinkToPage = entity.getIn(['field_link_to_page', 0, 'alias'], entity.getIn(['field_link_to_page', 0, 'uri']));
  const fieldLinkToPageTitle = entity.getIn(['field_link_to_page', 0, 'title']);
  const image = entity.getIn(['field_media_item', 0], Immutable.List());


  return (
    <article className="NodeCampaignPage">
      <div className="NodeCampaignPage__header">
        <Container>
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1 NodeCampaignPage__header__title">
              <h1>{title}</h1>
            </div>
            <div className="col-12 col-md-10 offset-md-1 NodeCampaignPage__header__body">
              <WysiwygField
                property="schema:text"
                html={body}
              />
            </div>
            <div className="col-6 NodeCampaignPage__header__cta">
              {fieldLink && fieldLinkTitle && (
                <Button href={fieldLink}>{fieldLinkTitle}</Button>
              )}
            </div>
            <div className="col-6 NodeCampaignPage__header__link">
              {fieldLinkToPage && fieldLinkToPageTitle && (
                <CoreLink to={fieldLinkToPage} className="Button Button--default">
                  {fieldLinkToPageTitle}
                  <div className="icon icon-arrow-right icon-variant-1" />
                </CoreLink>
              )}
            </div>
          </div>
        </Container>
      </div>
      <div className="NodeCampaignPage__hero">
        <Container>
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1 NodeCampaignPage__header__hero_image">
              {image.get('styles') && (
                <ImageFromField
                  className="ParagraphImage__image"
                  field={image}
                  imageStyles={Immutable.Map({
                    [SCREEN_MOBILE]: 'entity_hero_image_mobile',
                    [SCREEN_NORMAL]: 'entity_hero_image_desktop',
                  })}
                />
              )}
            </div>
          </div>
        </Container>
      </div>

      {/* Start of paragraphs */}
      {entity.get('field_paragraphs') ? (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', Immutable.List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            return (
              <FadeWrapper key={`paragraph:${id}`}>
                <Paragraph
                  id={id}
                  entity={paragraph.get('entity')}
                />
              </FadeWrapper>
            );
          })}
        </div>
      ) : null}
      {/* End of paragraphs */}

    </article>
  );
};

export default NodeCampaignPage;
